import AxiosBusiness from '@/services/api/business/axios_business'

export default {

  createAcl: (data) => {
    return AxiosBusiness.post('acl', data)
  },

  updateAcl: (aclId, data) => {
    return AxiosBusiness.put(`acl/${aclId}`, data)
  },

  deleteAcl: (aclId) => {
    return AxiosBusiness.delete(`acl/${aclId}`)
  },

  getAcl: (aclId) => {
    return AxiosBusiness.get(`acl/${aclId}`)
  },

  getAclsByCustomer: (customerId, params = {}) => {
    return AxiosBusiness.get(`acl/customer/${customerId}`, { params })
  },

  getMyAcls: (params = {}) => {
    return AxiosBusiness.get('acl/user/me', { params })
  },
}
